import moment from 'moment/moment';
import { addDays, addHours, addMinutes, getHours, getMinutes, isSameDay } from 'date-fns';
// import { TZDate } from "@date-fns/tz";
import { formatInTimeZone }from "date-fns-tz";

export const getChineseDateNow = () => moment.utc().add(8, 'hours').format();

// export const getAreWorkingHoursInChina = () => moment(getChineseDateNow()).utc().hour() < 20;

export const getShipmentDates = (isNew: boolean) => {
  const chineseDate = getChineseDateNow();
  const dates: number[] = isNew ? [2, 3] : [0, 1, 2];

  return dates.map((d: number) => moment(chineseDate).utc().add(d, 'days'));
};

export const getFBPShipmentDates = () => {
  const daysArray = [1, 2, 3];
  const now = new Date();
  const chinaDate = new Date(now.getTime() + 8 * 60 * 60 * 1000);
  return  daysArray.map(days => {
    const newDate = new Date(chinaDate);
    newDate.setUTCDate(newDate.getUTCDate() + days);
    return newDate;
  });
};

export const getShipmentDatesForCN = (daysArray: number[]) => {
  const now = new Date();
  const chineseDate = new Date(now.getTime() + 8 * 60 * 60 * 1000);
  return  daysArray.map(days => {
    const newDate = new Date(chineseDate);
    newDate.setUTCDate(newDate.getUTCDate() + days);
    return newDate;
  });
};

const convertToCN = (d?: string | Date) => (
  new Date(formatInTimeZone(d ? new Date(d) : new Date(), "+08:00", 'yyyy-MM-dd HH:mm:ss'))
)

export const getPickUpFirstDate = (startDate?: string) => {
  // последний слот в 23:30, сли до него осталось меньше 4 часов - сегодняшняя дата уже недоступна, вернем завтрашнюю
  const nowDate = addHours(convertToCN(startDate), 4);
  const minDate = addMinutes(nowDate, 30);
  return minDate;
}

const times = [
  "0:00", "0:30",
  "1:00", "1:30",
  "2:00", "2:30",
  "3:00", "3:30",
  "4:00", "4:30",
  "5:00", "5:30",
  "6:00", "6:30",
  "7:00", "7:30",
  "8:00", "8:30",
  "9:00", "9:30",
  "10:00", "10:30",
  "11:00", "11:30",
  "12:00", "12:30",
  "13:00", "13:30",
  "14:00", "14:30",
  "15:00", "15:30",
  "16:00", "16:30",
  "17:00", "17:30",
  "18:00", "18:30",
  "19:00", "19:30",
  "20:00", "20:30",
  "21:00", "21:30",
  "22:00", "22:30",
  "23:00", "23:30",
];

export const getTimeSlots = (date: string, startDate?: string) => {
  const selDate = new Date(date);
  const nowDate = addHours(convertToCN(startDate), 4);
  if (isSameDay(selDate, nowDate)) {
    return times.filter(t => {
      const nowH = getHours(nowDate);
      const nowM = getMinutes(nowDate);
      const [h, m] = t.split(":").map(v => +v);
      return h > nowH || (h === nowH && m > nowM);
    });
  }
  return times;
}

export const getPickUpLastDate = (date?: string) => {
  return addDays(convertToCN(date), 7)
}
